export const ENCRYPTED_STORAGE_KEYS = {
  accessToken: 'accessToken',
  bitToken: 'bitToken',
  refreshToken: 'refreshToken',
  chainItNftWalletAddress: 'CHAINIT_NFT_WALLET_ADDRESS',
  codeVerifier: 'codeVerifier',
  state: 'state',
  sessionToken: 'sessionToken',
  expiresIn: 'expiresIn',
  idToken: 'idToken',
  hasProfile: 'hasProfile',
  introPassed: 'introPassed',
  deviceId: 'deviceId',
  mintPlatform: 'mintPlatform',
  isLoggingDisabled: 'isLoggingDisabled',
  incodeUserId: 'incodeUserId',
  organizationId: 'organizationId',
  themeMode: 'themeMode',
  shippingDetails: 'shippingDetails',
  authStep: 'authStep',
  authEmails: 'authEmails',
  incodeInterviewId: 'incodeInterviewId',
  incodeToken: 'incodeToken',
  selfCustodyWalletAddress: 'selfCustodyWalletAddress',
  selfCustodyWalletMnemonic: 'selfCustodyWalletMnemonic',
  selfCustodyWalletPrivateKey: 'selfCustodyWalletPrivateKey',
};
